//-------------Importar librerias----------------------------
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
import TodoDataService from '../../hooks/services'
import styled from "styled-components";

// -----------Importar Archivos Estaticos------------------
import cvv from '../../assets/Imagenes/Sets/BBVA-Pagos/cvv.png'
import cards2 from '../../assets/Imagenes/Sets/BBVA-Pagos/cards2.png'
import cards1 from '../../assets/Imagenes/Sets/BBVA-Pagos/cards1.png'
import openpaysecuryty from '../../assets/Imagenes/Sets/BBVA-Pagos/openpay-securyty.PNG'

// -----------Importar Componentes de Terceros------------------
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';


import './style.css'

// -------------Valores Constantes-------------------------------
const StyleDragArea = styled.div`
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

  input[type=number] { -moz-appearance:textfield; }

  textarea:focus {
      background-color: white;
      color: black;
      border: 1px solid white !important;
      outline: none !important;
      outline-color: var(--color-amarilo) !important;
      box-shadow: 0 0 0 0.1rem var(--color-amarilo) !important;
    }
`;


const OpenPayBBVA = ({ EnviarMensaje, Style, CambiarFormaPago, PedidoCliente, OnClickHandleNext, Token }) => {
    const [DeviceSessionId, setDeviceSessionId] = useState('');
    const [Alerta, setAlerta] = useState(false);
    const [AlertaAutorizacion, setAlertaAutorizacion] = useState(false);
    const [Tarjeta, setTarjeta] = useState('');
    const [Mes, setMes] = useState('');
    const [Año, setAño] = useState('');
    const [Codigo, setCodigo] = useState('');
    const [Credenciales, setCredenciales] = useState('');
    const [AlertaPago, setAlertaPago] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [titulartarjeta, settitulartarjeta] = useState('');



    const HandleChangeNumber = (e) => {

        if (e.target.name === 'titular') {
            settitulartarjeta(e.target.value);
                        console.log(titulartarjeta);

        }


        if (e.target.name === 'Tarjeta') {
            if (e.target.value.length < 17) {
                setTarjeta(e.target.value);
            }
        }
        if (e.target.name === 'Año') {
            if (e.target.value.length < 3) {
                setAño(e.target.value);
            }
        }
        if (e.target.name === 'Mes') {
            if (e.target.value === '') {
                setMes('');
            }
            else {
                if (parseInt(e.target.value) < 13) {
                    setMes(e.target.value);
                }
            }
        }
        if (e.target.name === 'Codigo') {

            if (e.target.value === '') {
                setCodigo('');
            }
            else {
                if (parseInt(e.target.value) < 10000) {
                    setCodigo(e.target.value);
                }
            }

        }
    }

    const obtenerCredenciales = async () => {
        try {
            const credenciales = await TodoDataService.GetOpenPayCredenciales(Token);
            setCredenciales(credenciales);
            return credenciales;
        } catch (error) {
            console.error("Error al obtener credenciales de OpenPay:", error);
            return null;
        }
    }

    // Función encargada de realizar el cargo a la tarjeta.
    const successCallback = async (response) => {

        const chargeRequest = {
            "FolioOrigen": PedidoCliente.folio,
            "OperacionOrigen": PedidoCliente.operacion,
            "tokenId": response.data.id,
            'SessionId': DeviceSessionId,
            "use3dSecure": true,
            "RedirectUrl": TodoDataService.GetHost2() + "/SetsFunerarios/" + PedidoCliente.folio,
            "TitularTarjeta": titulartarjeta,
            'metodoPago': 'card',
            "importePago": 0.1,
            // "importePago": Math.trunc(PedidoCliente.total * 100) / 100,
        };

        const newWindow = window.open("", "_blank"); // Abre una ventana en blanco inmediatamente.

        if (!newWindow) {
            alert("Por favor, habilita las ventanas emergentes en tu navegador.");
            return;
        }

        try {
            const response = await TodoDataService.OpenpayCargoDebitoCredito(
                chargeRequest,
                `${TodoDataService.GetHostRestApi()}/pagos/openpaycargo`,
                Token
            );
            // Llama a la función adicional si es necesario.
            alert("Pago exitoso");
            setAlertaPago(true);
            EnviarMensaje();
            newWindow.location = response.paymentMethod.url; // Actualiza la ventana con la URL de pago.

        } catch (error) {
            newWindow.close(); // Cierra la ventana en caso de error.
            console.error(error);
            alert("Error al realizar el pago, consulte con su institución bancaria.");
            setAlerta(true);
        }
    };


    // Función encargada de generar una alerta, cuando se generar un error en la función para generar una un token de la tarjeta 
    const errorCallback = (response) => {
        const desc = response.data.description !== undefined ? response.data.description : response.message;
        setAlerta(true)
        alert("ERROR [" + response.status + "] " + desc);
        $("#pay-button").prop("disabled", false);
    };

    // // Función encargada de generar un token para la tarjeta de débito o crédito cargada en el formulario, para lo cual se validara la autenticidad y dependieno de la repuesta lalama a la funcion successCallback o errorCallback.
    const handlePayButtonClick = (event) => {
        event.preventDefault();
        $("#pay-button").prop("disabled", true);
        window.OpenPay.token.extractFormAndCreate('payment-form', successCallback, errorCallback);
    };




    // Función encargada a de generar device session id, indispensable para pode utilizar formularios de cobranza personalizados, es llamada al cargar el componente
    useEffect(() => {
        const initOpenPay = async () => {
            try {
                if (!window.OpenPay || !window.OpenPay.deviceData) {
                    console.error("OpenPay no está disponible");
                    return;
                }

                let Credenciales = await obtenerCredenciales();
                if (Credenciales !== null) {
                    window.OpenPay.setId(Credenciales.merchantId);
                    window.OpenPay.setApiKey(Credenciales.apiKey);
                    window.OpenPay.setSandboxMode(false);

                    const deviceSessionId = window.OpenPay.deviceData.setup("payment-form", "deviceIdHiddenFieldName");
                    setDeviceSessionId(deviceSessionId);
                } else {
                    console.warn("Credenciales OpenPay no disponibles");
                }
            } catch (error) {
                console.error("Error al inicializar OpenPay:", error);
            }
        };

        initOpenPay();
    }, []);


    return (
        AlertaPago === true
            ?
            <>
                <Typography sx={{ color: '#D14081', fontSize: '20px', fontWeight: 'bold !important' }}>
                    Si la validación de la información de pago no fue exitosa. Para resolver este inconveniente, por favor contáctenos a través de nuestras líneas de comunicación:
                    {' ' + TodoDataService.GetNumberCall()} para recibir asistencia. Su folio de servicio es: {PedidoCliente.folio}.
                </Typography>
            </>
            :
            <>
                <div id="head"></div>

                <div style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}>
                    <form id="payment-form">
                        <input type="hidden" id="token_id" name="token_id" />
                        <input type="hidden" name="use_card_points" id="use_card_points" value="false" />
                        <div className='Marcesina' >
                            <h2 className='titulopago'>Tarjeta de crédito o débito</h2>
                        </div>

                        <div style={{ margin: '10px' }}>
                            <div className='row' >
                                <div className='col-md-4'>
                                    <h4>Tarjetas de crédito</h4>
                                    <img className='cards' alt='Cards01' src={cards1} />

                                </div>
                                <div className='col-md-8'>
                                    <h4>Tarjetas de débito</h4>
                                    <img className='cards' alt='Cards01' src={cards2} />
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className='col-md-6'>
                                    <label>Nombre del titular</label>
                                    <input onChange={HandleChangeNumber} className='InputGenral form-control' name='titular' type="text" placeholder="Como aparece en la tarjeta" autocomplete="off" data-openpay-card="holder_name" />
                                </div>
                                <div className='col-md-6'>
                                    <label>Número de tarjeta</label>
                                    <StyleDragArea>
                                        <input value={Tarjeta} onChange={HandleChangeNumber} onKeyDown={(e) => {
                                            if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                e.preventDefault(); // Bloquea la tecla "e"
                                            }
                                        }} className='form-control InputGenral ' name='Tarjeta' type="number" autocomplete="off" data-openpay-card="card_number" />
                                    </StyleDragArea>
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className='col-md-6'>
                                    <label>Fecha de expiración</label>
                                    <div className='row' >
                                        <div className='col-5'>
                                            <StyleDragArea>
                                                <input value={Mes} onChange={HandleChangeNumber} onKeyDown={(e) => {
                                                    if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                        e.preventDefault(); // Bloquea la tecla "e"
                                                    }
                                                }} className='form-control InputGenral' type="number" name='Mes' placeholder="Mes" data-openpay-card="expiration_month" />
                                            </StyleDragArea>
                                        </div>
                                        <div className='col-2'>

                                        </div>
                                        <div className='col-5'>
                                            <StyleDragArea>
                                                <input value={Año} onChange={HandleChangeNumber} onKeyDown={(e) => {
                                                    if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                        e.preventDefault(); // Bloquea la tecla "e"
                                                    }
                                                }} className='form-control InputGenral' type="number" name='Año' placeholder="Año" data-openpay-card="expiration_year" />
                                            </StyleDragArea>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <label>Código de seguridad</label>
                                    <div className='row'>
                                        <div className='col-4'>
                                            <StyleDragArea>
                                                <input value={Codigo} onChange={HandleChangeNumber} onKeyDown={(e) => {
                                                    if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                        e.preventDefault(); // Bloquea la tecla "e"
                                                    }
                                                }} className='form-control InputGenral ' type="number" name='Codigo' placeholder="3 dígitos" autocomplete="off" data-openpay-card="cvv2" />
                                            </StyleDragArea>

                                        </div>
                                        <div className='col-8'>
                                            <img height={40} alt='Cards03' className='cards' src={cvv} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row mt-4'>
                                <div className='col-md-5'></div>
                                <div className='col-md-7'>
                                    <img className='cards' alt='Cards04' src={openpaysecuryty} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end' }} className=' mt-4'>
                                <Style style={{ width: '200px' }}>
                                    <button className="btnAmarilloChicos " id="pay-button" onClick={handlePayButtonClick}>Pagar</button>
                                </Style>
                            </div>
                            <div className='row mt-4'></div>
                        </div>
                    </form>

                </div>

                {
                    Alerta === true
                        ?
                        <div>
                            <Typography sx={{ color: '#D14081', fontSize: '20px', fontWeight: 'bold !important' }}>
                                Pudes cambiar tu forma de pago si tienes problemas para realizar la transaccion.
                            </Typography>

                            <Link onClick={CambiarFormaPago} align="left" color='#D14081' sx={{ marginLeft: '20px', fontSize: '15px', fontFamily: 'Itaca ', '&:hover': { color: '#D95F96' } }} component="button" variant="body2" >
                                Cambiar forma de pago
                            </Link>
                        </div>
                        :
                        <></>
                }

                {
                    AlertaAutorizacion === true
                        ?
                        <div>
                            <Typography sx={{ color: '#D14081', fontSize: '20px', fontWeight: 'bold !important' }}>
                                Su cargo se ha realizado con éxito. Sin embargo, ocurrió un error al intentar autorizar su servicio. Por favor, contacte a nuestro servicio de atención al cliente: {TodoDataService.GetNumberCall()} para recibir asistencia. Su folio de servicio es: {PedidoCliente.folio}.
                            </Typography>
                        </div>
                        :
                        <></>
                }
            </>
    );
}

export default OpenPayBBVA;



